<template>
  <div class="pendingPaymentInfo">
    <topTitle title="确认订单"></topTitle>
    <div class="addressReceiving">
      <div class="dd"><img src="../../assets/localImage/address.png" alt=""></div>
      <div class="xx addAdress"  v-if="noaddAdress == true" @click="goAddAdress()" >
          <p>请先添加收货地址</p>
      </div>
      <div class="xx" v-else  @click="chooseAdress()" >
          <h2>收货人：{{addressData.name}} <span>{{addressData.mobile}}</span></h2>
          <p>{{addressData.country}} {{addressData.province}} {{addressData.city}} {{addressData.county}}</p>
      </div>
      <div class="jr"><img src="../../assets/localImage/path.png" alt=""></div>
    </div>
    <div class="purchase" >
      <div class="od_cont" @click="goDetail(item.goods_id)" v-for="(item,i) in orderData" :key="i">
        <div class="od_cont_img">
          <img :src="item.goods_image ? item.goods_image : $store.state.defaultgwc" alt />
        </div>

        <div class="od_cont_xinxi">
          <h4 class="od_cont_name">
            <span class="l van-multi-ellipsis--l2">{{item.name}}</span>
            <!-- <span class="r color-yellow">￥760/桶</span> -->
            <div class="r">
              <p>¥{{item.original_price}}</p>
              <p class="color-999" v-if="item.point == null" >重消币:¥0</p>
			  <p class="color-999" v-else >重消币:¥{{item.point}}</p>
            </div>
          </h4>
          <h4 class="od_cont_font">
            <p>数量：x{{item.num}}</p>
          </h4>
        </div>
      </div>
    </div>
    <div class="list">
      <div class="item">
        <div>配送方式</div>
        <div>快递运输</div>
      </div>
      <div class="item">
        <div>发票</div>
        <div @click="xzfp()" v-show="fptype == 0">
          本次不开具发票
          <div class="jr"><img src="../../assets/localImage/path.png" alt=""></div>
        </div>
        <div @click="xzfp()" v-show="fptype == 1">
          普通
          <span class="color-js">电子</span> 发票（个人）
          <div class="jr"><img src="../../assets/localImage/path.png" alt=""></div>
        </div>
        <div @click="xzfp()" v-show="fptype == 2">
          普通
          <span class="color-js">电子</span> 发票（公司）
          <div class="jr"><img src="../../assets/localImage/path.png" alt=""></div>
        </div>
      </div>
      <div class="item">
        <div>运费</div>
        <div>¥{{totalPriceData.freight_price}}</div>
      </div>
      <div class="item">
        <div>付款方式</div>
        <div>微信支付</div>
      </div>
      <div class="item">
        <div>重消币</div>
        <div class="color-js" v-if="this.consumPoint < totalPriceData.exchange_point" >余额不足</div>
		<div class="color-js" v-else >¥{{totalPriceData.exchange_point}}</div>
      </div>
      <div class="item">
        <div>实付款</div>
        <div class="color-js">¥{{totalPriceData.total_price}}</div>
      </div>
    </div>
	

    <div class="pay">
      <p>
        合计：
        <span>¥{{totalPriceData.total_price}}</span>
      </p>
      <button @click="goPay(totalPriceData.total_price)" >去支付</button>
    </div>
  </div>
</template>

<script>
import topTitle from "../../components/topTitle.vue";
import addressReceiving from "../../components/addressReceiving.vue";

import { Dialog } from "vant";
export default {
  name: "ConfirmationOrder",
  data() {
    return {
      radio: "2",
      noaddAdress:false,
      addressData:{},
      orderData:{},
      totalPriceData:{},
      addressInfoData:{},
      consumPoint:0,
      changeAdress:this.$route.query.changeAdVal,
      chooseState:this.$route.query.changeState,
      isCarts:localStorage.getItem("isCart"),
      //adresInfos:this.$route.query.adresInfo
      fptype : this.$route.query.fptype,
    };
  },
  components: {
    topTitle,
    addressReceiving
  },
  mounted(){
    this.getOrderInfo();
	  this.getPerson();
    this.getChState();
    if(this.$route.query.changeState == true){
      this.chooseState = true;
    }else{
       this.chooseState = false;
    }
     if(this.$route.query.fptype == undefined){
      this.fptype = 0;
    }else{
       this.fptype =  this.$route.query.fptype
    }
	  console.log(this.$route.query.fptype,this.chooseState,'987654321')
  },
  methods: {
    //点击进去发票
    xzfp(){
      console.log(this.totalPriceData.tax_receipt_status)
      this.$router.push({path:'./invoice', query:{tax_receipt_status: this.totalPriceData.tax_receipt_status == 1 ?  false : true }})
    },

    getOrderInfo(){
      // let param ={
      //   way : BUY_NOW
      // }
      console.log(this.isCarts);
      if(this.isCarts == 1){
        this.getRequest(`trade/carts/checked`,{way:'CART'}).then(res => {
				  console.log(res,"cart")
					this.orderData=res.data.data.cart_list[0].sku_list;
					this.totalPriceData=res.data.data.total_price;
					console.log(this.orderData,this.totalPriceData)
				})
      }else{
        this.getRequest(`trade/carts/checked`,{way:'BUY_NOW'}).then(res => {
				  console.log(res)
					console.log("AAAA5")
					this.orderData=res.data.data.cart_list[0].sku_list;
					this.totalPriceData=res.data.data.total_price;
					console.log(this.orderData,this.totalPriceData)
				})
      }
    	  
    },
    
    goDetail(e){
       localStorage.setItem("isCart", 1);
      this.$router.push({
        path:'./goodsDetail',
        query :{
          goods_id:e
        }
        })
    },
	getPerson(){
	   this.getRequest(`members`).then(res => {
		   this.consumPoint = res.data.data.consum_point
		})	  
	},
	getChState(){
		if(this.chooseState == true){
			this.addressData = this.changeAdress;
			this.postRequest(`trade/checkout-params/address-id/${this.changeAdress.addr_id}`).then(res => {
			})	
		}else{
			 this.getRequest(`members/addresses`).then(res => {
         console.log(res)
			   if(res.data.code == 1){
			    this.noaddAdress = true;
			   }else{
			      this.addressData = res.data.data[0];
			  	this.postRequest(`trade/checkout-params/address-id/${this.addressData.addr_id}`).then(res => {
			 	})
			   }
			 })	
			// this.addressData = this.addressInfoData;
		}
	},
	
    goAddAdress(){
		this.$router.push({
      path : './addAdresInfo',
      query:{
        order:true
      }
    })
    },
	chooseAdress(){
		this.$router.replace({
		path:'./chooseAdress',
		query :{
			addressTapTrue:true
		}
		})
	},
	  goPay(){
      let param
      if(this.isCarts == 1){
         param ={
          way:'CART'
        }
      }else{
         param = {
          way:'BUY_NOW'
        }
      }
		  this.postRequest(`trade/create`,param).then(res => {
			  console.log(res,'ggggggg');
			  this.$router.push({
			  path:'./orderPay',
			  query:{
			  	 payData:res.data.data
			  }
			  })
		  })
		  
	  }
	  
  }
};
</script>


<style scoped lang='less'>
.pendingPaymentInfo {
  padding-bottom: 120px;
  .jr{
        width: 12px;
        height: 22px;
        display: inline-block;
        img{
          width: 100%;
          height: 100%;
        }
    }
  .pendingtop {
    width: 100%;
    height: 180px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    h2 {
      font-size: 32px;
    }
    font-family: AlibabaPuHuiTiM;
    background: linear-gradient(to right, #ff9345, #fd5d46, #fd4843);
    > div {
      width: 101px;
      height: 101px;
      margin-right: 27px;
    }
  }
  .purchase {
    width: 94%;
    margin: 0 auto;
    background-color: white;
    margin-top: 20px;
    overflow: hidden;
    border-radius: 8px;
    .shopName {
      color: #333333;
      font-size: 26px;
      padding: 24px;
      .r {
        color: #ff1919;
        font-size: 26px;
      }
    }
    .od_cont {
      width: 100%;
      box-sizing: border-box;
      padding: 10px 24px;
      padding-bottom: 45px;
      overflow: hidden;
      .od_cont_img {
        width: 180px;
        height: 180px;
        overflow: hidden;
        float: left;
        border-radius: 8px;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .od_cont_xinxi {
        width: 460px;
        height: 180px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        float: right;
        overflow: hidden;
        > h4 {
          line-height: 53px;
        }
        .od_cont_name {
          color: #333333;
          // line-height: 30px;
          .l {
            width: 280px;
            height: 110px;
            font-size: 26px;
            display: inline-block;
            line-height: 40px;
          }
          .r {
            font-size: 24px;
            float: right;
            p {
              text-align: right;
            }
            line-height: 40px;
          }
        }

        .od_cont_font {
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          line-height: 40px;
          color: rgba(153, 153, 153, 1);
          .color-js {
            font-size: 24px;
          }
        }
      }
    }
  }
  .p {
    height: 74px;
    line-height: 74px;
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(158, 158, 158, 1);
    padding-left: 32px;
  }
  .list {
    background: #ffffff;
    margin-top: 20px;
    .item {
      width: 100%;
      height: 96px;
      padding: 0 33px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #f1f1f1;
      .wx {
        img {
          width: 42px;
          height: 37px;
          margin-right: 15px;
          float: left;
        }
      }
      .zfb {
        img {
          width: 38px;
          height: 38px;
          margin-right: 15px;
          float: left;
        }
      }

      /deep/.van-radio__icon--checked .van-icon {
        background: linear-gradient(to right, #fc4d1d, #cf1104);
        border-color: transparent;
      }
      div {
        font-size: 30px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        .color-js {
          color: #ff1919;
        }
      }
      .color-js {
        color: #ff1919;
      }
    }
  }
  .pay {
    width: 100%;
    height: 94px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 40px;
    margin-top: 20px;
	position: fixed;
	bottom: 0;
    p {
      font-size: 26px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      span {
        color: #ff1919;
        font-size: 30px;
      }
    }
    button {
      width: 217px;
      height: 74px;
      text-align: center;
      line-height: 74px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      background: linear-gradient(
        270deg,
        rgba(205, 15, 2, 1) 0%,
        rgba(229, 47, 35, 1) 60%,
        rgba(255, 81, 28, 1) 100%
      );
      border-radius: 37px;
    }
  }
  .addressReceiving::before{
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 6px;
    background: repeating-linear-gradient(-45deg, #ff6c6c 0, #ff6c6c 20%, transparent 0, transparent 25%, #1989fa 0, #1989fa 45%, transparent 0, transparent 50%);
    background-size: 200px;
    content: '';
}
.addressReceiving{
    width: 100%;
    height: 180px;
    background-color: #ffffff;
    display: flex;
    padding: 22px 32px;
    justify-content: space-around;
    align-items: center;
    position: relative;
    .dd{
        width: 30px;
        height: 36px;
        margin-top: -30px;
    }
    .jr{
        width: 12px;
        height: 22px;
    }
    .xx{
        width: 560px;
        height: 100%;
        display: flex;
        flex-direction: column;
        // justify-content: space-between;
        h2{
            font-size:28px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(51,51,51,1);
            span{margin-left: 50px;}
            margin-top: 10px;
        }
        p{
            font-size:26px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(119,119,119,1);
            margin-top: 10px;
        }
    }
    .addAdress{
        p{
            margin-top: 50px;
            color: #333333;
        }
    }
}
}
</style>


